import { MALEK_CART_ITEMS_KEY, MALEK_STORE_TOKEN_KEY, MALEK_USERNAME_KEY, MALEK_WISHLIST_KEY } from "src/constants/storageKeys";

export const clearAuthStorage = () => {
    localStorage.removeItem(MALEK_STORE_TOKEN_KEY);
    localStorage.removeItem(MALEK_USERNAME_KEY);
    localStorage.removeItem(MALEK_WISHLIST_KEY);
}

export const clearAllStorage = () => {
    clearAuthStorage();
    localStorage.removeItem(MALEK_CART_ITEMS_KEY);
}